import React, { useEffect } from "react";
import { Text, Divider, Button as RNButton } from "react-native-paper";
import { StyleSheet, View, ScrollView, ImageBackground } from "react-native";
import {
  whiteColor,
  blackColor,
  descriptionColor,
  dividerColor,
} from "../../common/colors";
import questions from "../SingleTest/questions";
import { connect } from "react-redux";
import tempResult from "./resultsTemporary";
import Accordion from "../../common/Accordion";
import PolarChart from "../../common/PolarChart";
import predictColor from "../../common/helpers/predictColor";
import BlockColors from "../BlockColors";
import Button from "../../common/Button";
import routes from "../../routing/routes";
import getOnlyTwoDominateColors from "./../../common/helpers/onlyTwoDominateColors";
import PageContainer from "../../common/PageContainer";
import { actionCreators } from "./action";
import windowWidth from "../../common/windowWidth";
import { iconRight } from "../../common/ModalIcons";
import { Dimensions } from "react-native";
import t from "../../translations";

const Results = (props) => {
  useEffect(() => {
    props.fetchResult();
  }, []);

  const answers = props.answers;

  const result = { R: 0, B: 0, G: 0, Y: 0 };

  const textStyle = {
    fontSize: 16,
    padding: 5,
    textAlign: "center",
    color: "black",
    lineHeight: 20,
    letterSpacing: 1.25,
  };

  const onClickGoToSettings = () => {
    props.navigation.navigate(routes.Settings);
  };

  {
    answers &&
      answers.map((o) => {
        result[questions[o.question - 1].colors[0]] =
          result[questions[o.question - 1].colors[0]] + (100 - o.value);
        result[questions[o.question - 1].colors[1]] =
          result[questions[o.question - 1].colors[1]] + o.value;
      });
  }

  const myColors = getOnlyTwoDominateColors(result);

  const getNameOfMyColors = (colors) => {
    if (colors[0].colorType === "BLUE" && colors[1].colorType === "RED")
      return t('results_blue_red');
    if (colors[0].colorType === "BLUE" && colors[1].colorType === "YELLOW")
      return t('results_blue_yellow');
    if (colors[0].colorType === "BLUE" && colors[1].colorType === "GREEN")
      return t('results_blue_green');
    if (colors[0].colorType === "RED" && colors[1].colorType === "BLUE")
      return t('results_red_blue');
    if (colors[0].colorType === "RED" && colors[1].colorType === "YELLOW")
      return t('results_red_yellow');
    if (colors[0].colorType === "RED" && colors[1].colorType === "GREEN")
      return t('results_red_green');
    if (colors[0].colorType === "YELLOW" && colors[1].colorType === "BLUE")
      return t('results_yellow_blue');
    if (colors[0].colorType === "YELLOW" && colors[1].colorType === "RED")
      return t('results_yellow_red');
    if (colors[0].colorType === "YELLOW" && colors[1].colorType === "GREEN")
      return t('results_yellow_green');
    if (colors[0].colorType === "GREEN" && colors[1].colorType === "RED")
      return t('results_green_red');
    if (colors[0].colorType === "GREEN" && colors[1].colorType === "BLUE")
      return t('results_green_blue');
    if (colors[0].colorType === "GREEN" && colors[1].colorType === "YELLOW")
      return t('results_green_yellow');
  };

  return answers ? (
    <PageContainer
      {...props}
      isSettingsIcon={true}
      onClickGoToSettings={onClickGoToSettings}
      isResult={true}
      noBackground={true}
    >
      <View style={styles.titleContainer}>
        <Text style={styles.title}>{ t('results_title') }</Text>
        <Text style={styles.subtitle}>{getNameOfMyColors(myColors)}</Text>
      </View>
      <PolarChart result={result} language={props.language}/>
      <BlockColors result={result} />
      <View style={styles.buttonsContainer}>
        <RNButton
          contentStyle={{ flexDirection: "row-reverse" }}
          icon={iconRight}
          mode="text"
          style={styles.button}
          onPress={() => props.setActiveFooterMenu(2)}
        >
         { t('results_more') }
        </RNButton>
        <RNButton
          contentStyle={{ flexDirection: "row-reverse" }}
          icon="refresh"
          mode="text"
          style={styles.button}
          onPress={() => props.navigation.navigate(routes.ModalTest)}
        >
             { t('results_repeat') }
        </RNButton>
      </View>
      <Accordion
        colorType={predictColor(result.R, result.B, result.G, result.Y)}
      />
    </PageContainer>
  ) : (
    <PageContainer
      {...props}
      isSettingsIcon={true}
      onClickGoToSettings={onClickGoToSettings}
      isResult={false}
    >
      <View style={styles.container}>
        <Text style={textStyle}>{t('result_no_results_1')}</Text>
        <Text style={textStyle}>{t('result_no_results_2')}</Text>
        <Button
          onPress={() => props.navigation.navigate(routes.ModalTest)}
          value={t('result_do_test')}
          style={{ marginTop: 40, marginBottom: 90 }}
        />
        <View style={styles.buttonsContainer}>
          <RNButton
            contentStyle={{ flexDirection: "row-reverse" }}
            icon={iconRight}
            mode="text"
            style={styles.button}
            onPress={() => props.setActiveFooterMenu(2)}
          >
            {t('result_more_about_test')}
          </RNButton>
        </View>
      </View>
    </PageContainer>
  );
};

const mapStateToProps = (state) => {
  // only for development
  // const answers = state.test ? state.test : tempResult;
  const answers = state.test ? state.test : null;
  const language = state.language ? state.language : null;
  return { answers, language };
};

export default connect(mapStateToProps, actionCreators)(Results);

const heightDimension = Dimensions.get("window").height - 150;

const styles = StyleSheet.create({
  wrapper: {
    alignItems: "center",
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    paddingTop: 0,
    width: "100%",
    backgroundColor: whiteColor,
  },
  text: {
    color: blackColor,
  },
  textTitle: {
    fontSize: 16,
    lineHeight: 16,
    letterSpacing: 0.25,
    color: blackColor,
    fontWeight: "bold",
    textTransform: "uppercase",
  },
  textSubtitle: {
    fontSize: 12,
    lineHeight: 24,
    letterSpacing: 0.15,
    textTransform: "uppercase",
    color: blackColor,
  },
  textdescriptionDesign: {
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0.25,
    color: descriptionColor,
  },
  titleContainer: {
    alignItems: "center",
  },
  title: {
    fontSize: 16,
    lineHeight: 26,
    letterSpacing: 1.25,
    paddingLeft: 0,
    paddingTop: 50,
    color: blackColor,
    textTransform: "uppercase",
  },
  subtitle: {
    fontSize: 20,
    lineHeight: 26,
    paddingLeft: 0,
    letterSpacing: 1.25,
    paddingBottom: 50,
    paddingTop: 0,
    color: blackColor,
    textTransform: "uppercase",
    fontWeight: "400",
  },
  titleColor: {
    textAlign: "center",
    fontSize: 16,
    lineHeight: 16,
    letterSpacing: 1.25,
    paddingBottom: 16,
    paddingTop: 10,
    color: blackColor,
  },
  contentContainer: {
    backgroundColor: whiteColor,
    color: blackColor,
    width: "100%",
  },
  container: {
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center",
    width: "100%",
    height: heightDimension,
  },
  titleOne: {
    textAlign: "left",
    fontSize: 24,
    lineHeight: 16,
    paddingTop: 20,
    letterSpacing: 0.15,
  },
  divider: {
    width: "100%",
    backgroundColor: dividerColor,
  },
  scrollView: {
    backgroundColor: whiteColor,
    paddingBottom: 30,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    paddingTop: 0,
    width: "100%",
  },
  containerButtons: {
    backgroundColor: whiteColor,
    width: 360,
    alignItems: "center",
    alignContent: "flex-start",
    justifyContent: "flex-start",
  },
  icons: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    marginTop: 30,
    width: "95%",
  },
  screenBackground: {
    width: "100%",
    height: "110%",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    paddingTop: 0,
  },
  buttonsContainer: {
    alignItems: "flex-end",
    alignSelf: "flex-end",
    marginRight: 30,
  },
  button: {
    margin: 10,
    borderBottomWidth: 1.5,
    borderColor: "black",
  },
  welcome: {
    textAlign: "center",
    fontSize: 24,
    paddingBottom: 24,
    paddingTop: 24,
    textTransform: "uppercase",
  },
  textDescription: {
    fontSize: 16,
    marginBottom: 20,
  },
});
